import Seo from "@/components/Seo";
import { useEffect, useState } from "react";
import axios from "axios";
import Lenis from "lenis";
import Navbar from "@/components/portfolio/Navbar";
import HeroCenter from "@/components/portfolio/HeroCenter";
import Education from "@/components/portfolio/Education";
import ImpactBar from "@/components/portfolio/ImpactBar";
import ProjectsGallery from "@/components/portfolio/ProjectsGallery";
import About from "@/components/portfolio/About";
import Timeline from "@/components/portfolio/Timeline";
import Skills from "@/components/portfolio/Skills";
import Contact from "@/components/portfolio/Contact";
import Footer from "@/components/portfolio/Footer";
import ChatWidget from "@/components/portfolio/ChatWidget";

export default function Home() {
  const [content, setContent] = useState(null);
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/api/content`)
      .then((r) => setContent(r.data))
      .catch(() => {});
  }, []);
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, anchors: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);
  return (
    <div className="bg-[#0A0B0E] text-[#F5F6FA] min-h-screen relative grain" data-testid="portfolio-home">
      <Seo
        title="Vijay Rajput — Design Leader & Creative Professional"
        ogTitle="Vijay Rajput — Design Leadership Portfolio"
        ogDescription="Explore selected work across branding, campaigns, performance creative, digital design and creative leadership."
        siteName="Vijay Rajput"
        description="Multidisciplinary design leader with 9+ years of experience in brand identity, creative direction, marketing design, performance creative and team leadership."
        image="/vijay-photo.jpg"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "Person",
          name: "Vijay Rajput",
          jobTitle: "Deputy Manager — Design",
          email: "kumar.edu12vk@gmail.com",
          telephone: "+91 9888001772",
          alumniOf: { "@type": "CollegeOrUniversity", name: "Chandigarh University" },
          knowsAbout: ["Creative Direction", "Brand Identity", "Marketing Design", "Performance Creative", "Design Leadership", "AI-Enabled Workflows"],
        }}
      />
      <Navbar />
      <main>
        <HeroCenter stats={content?.hero_stats} />
        <Education />
        <ImpactBar metrics={content?.ticker_items} />
        <ProjectsGallery />
        <About />
        <Timeline />
        <Skills />
        <Contact />
      </main>
      <Footer />
      <ChatWidget />
    </div>
  );
}
